export class VoiceCallAssistance {
  step: number;
  phoneNumber: string;

  displayedMessage: boolean;
  displayedMessageValue?: string;

  networkBarsNumber: number;
  operatorName: string;
  appearanceProblem: string;

  audioProblem: boolean;
  audioProblemValues?: Array<string>;

  problemType: string;
  problemTypeContact?: string;

  problemDestination: string;

  oldOperatorPhonePurchased: boolean;
  unlockedPhone?: boolean;

  imeiPhone: number;
  brandPhone: string;
  modelPhone: string;
  crossTestDate: string;
  crossTestBrandPhone: string;
  crossTestModelPhone: string;
  crossTestResult: boolean;
  occurrenceFrequencyProblem: string;
  usageType: string;

  operatorProblem: boolean;
  operatorProblemValue?: string;

  correspondentProblem: boolean;
  correspondentProblemValue?: string;

  incidentInformation: string;
  incidentMagnitude?: string;
  incidentMagnitudeCountry?: string;

  lastCallProblemCorrespondent: string;
  lastCallProblemOperator: string;
  lastCallProblemDate: string;
  lastCallProblemAddress: string;
  lastCallProblemZipCode: string;
  lastCallProblemCity: string;
}
